import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"
import { User } from "@/models"

interface ICreateUserForm {
  name: string
  email: string
  password: string
  referrerId?: string
  partnerSlug?: string
}

export interface IUseCreateUserArgs {
  user: ICreateUserForm
  paymentToken: string
  turnstileToken: string
  packageSubscriptionId?: string
}

export async function createUser(user: ICreateUserForm, paymentToken: string, turnstileToken: string, packageSubscriptionId?: string) {
  const params: { token: string, packageSubscriptionId?: string } = {
    token: paymentToken,
  }

  if (packageSubscriptionId) {
    params.packageSubscriptionId = packageSubscriptionId
  }

  const response = await axios.postForm(`api/user/create`, { ...user, captchaToken: turnstileToken }, {
    params,
  })

  return User.fromResponse(response.data.Data)
}

const CREATE_USER_QUERY_KEY = "createUser"

export function useCreateUser() {
  return useMutation({
    mutationKey: [CREATE_USER_QUERY_KEY],
    mutationFn: ({ user, paymentToken, packageSubscriptionId, turnstileToken }: IUseCreateUserArgs) =>
      createUser(
        user,
        paymentToken,
        turnstileToken,
        packageSubscriptionId,
      ),
  })
}
